export default __webpack_public_path__ + "static/media/8.f9f4883d.jpeg";